import { render, staticRenderFns } from "./salary_match_config.vue?vue&type=template&id=40b90796&scoped=true"
import script from "./salary_match_config.vue?vue&type=script&lang=js"
export * from "./salary_match_config.vue?vue&type=script&lang=js"
import style0 from "./salary_match_config.vue?vue&type=style&index=0&id=40b90796&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b90796",
  null
  
)

export default component.exports